export class ACMModel {
  constructor ({ cvlJson, acmModel }) {
    const parseCvl = (cvl) => {
      // eslint-disable-next-line camelcase
      return Object.values(cvl).reduce((acc, { provider_id, provider_name, policy_url }) => ({
        ...acc,
        [provider_id]: {
          id: provider_id,
          name: provider_name,
          policyUrl: policy_url,
          description: ''
        }
      }), {})
    }
    this.cvlJson = cvlJson
    this.cvl = parseCvl(cvlJson)
    this.consents = acmModel || {}
    this.encode = this.encode.bind(this)
    this.updateModel = this.updateModel.bind(this)
    this.getConsents = this.getConsents.bind(this)
    this.acmString = this.encode()
  }

  encode () {
    const isEmpty = obj => !Object.keys(obj).length
    if (isEmpty(this.consents)) return '1~'

    const ids = Object.entries(this.consents).filter(([ignore, { consent }]) => consent).map(([id, ignore]) => id).join('.')
    return `1~${ids}`
  }

  updateModel (consents) {
    this.consents = consents
    this.acmString = this.encode()
  }

  getConsents () {
    return this.consents
  }

  consentToAll () {
    this.consents = Object.keys(this.cvl).reduce((acc, id) => ({ ...acc, ...{ [id]: { consent: true } } }), {})
    this.acmString = this.encode()
  }

  dissentToAll () {
    this.consents = {}
    this.acmString = this.encode()
  }

  hasUserConsentedToAll () {
    const cvlIds = Object.keys(this.cvl)
    return cvlIds.every(id => this.consents[id] && this.consents[id].consent)
  }

  hasUserDissentedToAll () {
    const cvlIds = Object.keys(this.cvl)
    return cvlIds.every(id => !(this.consents[id] && this.consents[id].consent))
  }

  getUiModel () {
    return {
      cvlJson: this.cvlJson,
      cvl: this.cvl,
      consents: this.consents
    }
  }
}
